import React from "react";
import { Dialog, makeStyles, Typography, Box } from "@material-ui/core";
import { useState, useContext, useEffect } from "react";
import { Autocomplete } from "@material-ui/lab";
import MROTextField from "components/form_components/TextField";
import MROButton from "components/buttons";
import { ToastMessageContext } from "lib/contexts/message_context";
import { getOrganisationId } from "lib/utils/common_utils";
import LoadingIndicator from "components/universal/loading_indicator";
import MySmsServices from "lib/services/api/sms/my_sms_service";
import ReportsServices from "lib/services/api/reports/reports";

const useStyles = makeStyles(() => {
  return {
    popper: { maxHeight: "250px", overflow: "hidden" },
  };
});

const UsersAction = (props) => {
  const classes = useStyles();
  const { handleCloseAction, currentSelection, refetch } = props;
  const message = useContext(ToastMessageContext);

  const [usersList, setUsersList] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [loading, setLoading] = useState(false);

  const getUsersList = async () => {
    setLoading(true);

    try {
      const params = {
        organisation_id: getOrganisationId(),
      };
      const userListResponse = await MySmsServices.getUsersList(params);
      if (userListResponse?.success) {
        const transformedUserOptions =
          userListResponse?.data?.user?.map((user) => {
            return { id: user?.id, value: user?.user_name };
          }) || [];
        setUsersList(transformedUserOptions);
        if (currentSelection?.report_users?.length > 0) {
          let previouslySelected =
            transformedUserOptions?.filter((item) =>
              currentSelection?.report_users?.find(
                (selId) => selId?.user_id === item.id
              )
            ) || [];
          setSelectedUsers([...previouslySelected]);
        }
      } else {
        throw new Error();
      }
    } catch (err) {
      message.showToastMessage({
        message: "Something went wrong while fetching options. Try again!",
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUsersList();
  }, []);

  const getPayload = () => {
    const formData = new FormData();
    formData.append("organisation_id", getOrganisationId());
    formData.append("report_id", currentSelection?.id);

    if (Array.isArray(selectedUsers)) {
      selectedUsers.forEach((selectedUser, index) => {
        if (!selectedUser) {
          return;
        }
        formData.append(`users_id[${[index]}]`, selectedUser?.id);
      });
    }
    return formData;
  };

  const handleSubmitForm = async () => {
    setIsSubmitting(true);
    try {
      const payload = getPayload();
      const response = await ReportsServices.updateReportUsers(payload);
      if (response.success) {
        message.showToastMessage({
          message: "Users updated succesfully",
          variant: "success",
        });
        refetch();
        handleCloseAction();
        setIsSubmitting(false);
      } else {
        throw new Error(response?.error);
      }
    } catch (error) {
      setIsSubmitting(false);
      message.showToastMessage({
        message:
          error?.message ||
          error?.errors ||
          "Something went wrong while submitting the form.",
        variant: "error",
      });
    }
  };

  return (
    <Dialog maxWidth="md" open={true} onClose={handleCloseAction}>
      <Box
        style={{
          padding: "1rem",
          display: "flex",
          flexDirection: "column",
          gap: "0.75rem",
          height: "400px",
          width: "600px",
        }}>
        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}>
          <Typography variant="body1" color="primary">
            Report Users
          </Typography>

          <Typography variant="body1">
            {currentSelection?.report_number || ""}
          </Typography>
        </Box>

        {loading ? (
          <Box
            style={{
              width: "100%",
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}>
            <LoadingIndicator />
          </Box>
        ) : (
          <Box
            style={{
              width: "100%",
              flex: 1,
              overflowY: "scroll",
              overflowX: "hidden",
              padding: "0.5rem 0rem",
            }}>
            <Typography variant="body2" style={{ fontWeight: "bold" }}>
              Users
            </Typography>

            <Autocomplete
              classes={{ popper: classes.popper }}
              getOptionSelected={(option, value) => option.id === value.id}
              value={selectedUsers || []}
              multiple
              getOptionLabel={(option) => option?.value || ""}
              options={usersList || []}
              fullWidth
              onChange={(event, value) => {
                setSelectedUsers(value);
              }}
              renderInput={(params) => (
                <MROTextField
                  {...params}
                  placeholder="User search"
                  margin="normal"
                  variant="standard"
                  id="test"
                  InputLabelProps={{ shrink: true }}
                  helperText={
                    "Search and select Users who you want to see this report "
                  }
                />
              )}
            />
          </Box>
        )}
      </Box>

      <Box
        style={{
          padding: "1rem",
          display: "flex",
          justifyContent: "flex-end",
          gap: "1rem",
        }}>
        <MROButton
          disabled={loading}
          type="button"
          variant={"contained"}
          onClick={handleCloseAction}>
          Cancel
        </MROButton>
        <MROButton
          loading={isSubmitting}
          disabled={loading}
          type="submit"
          variant={"contained"}
          color="primary"
          onClick={handleSubmitForm}>
          Complete
        </MROButton>
      </Box>
    </Dialog>
  );
};

export default UsersAction;
